import { ReactElement } from 'react';
import InformationCard from './components/InformationCard';
import { Box } from '@mui/material';
// import UserDetailsForm from '../profile/components/UserDetailsForm';

const AccountDetailPage = (): ReactElement => (
    <Box className="account-detail-wrapper">
        <InformationCard />
    </Box>
);

export default AccountDetailPage;
